/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect } from "react";
import { closelightbox } from "../../util/Functions";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Typography } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import cardImage from "../../images/card.png";

const CardsCompany = (props) => {
  useEffect(() => {}, []);

  return (
		<Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle style={{marginLeft: "50px"}}>
					Tarjetas de {props.contentModal.customer.general.gname}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent style={{paddingBottom: "0"}}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
							<img src={cardImage} />
            </Grid>

						<Grid item xs={6} style={{ marginTop: "25px" }}>
							<Typography style={{ color: "green" }}>Tarjetas activadas</Typography> 
							<b>{props.contentModal.assigned}</b>
							<Typography style={{ color: "red", marginTop: "16px" }}>Tarjetas por activar</Typography>							
							<b>{props.contentModal.unassigned}</b>
						</Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{marginTop: "0"}}>
          <Button variant="contained" onClick={closelightbox} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>    
  );
};

export default CardsCompany;